// Quantity stepper — wires the − / + buttons to the typeable number input.
// The input keeps name="quantity" so the product form reads it unchanged; this
// component only steps and clamps the value, then fires a bubbling change event
// so any listeners (e.g. cart line updates) react the same as manual typing.
if (!window.DigitalizModules) window.DigitalizModules = {};
if (!window.DigitalizModules.ProductQuantity) {
  class ProductQuantity {
    constructor(el) {
      this.el = el;
      this.input = el.querySelector("[data-qty-input]");
      this.minusBtn = el.querySelector("[data-qty-minus]");
      this.plusBtn = el.querySelector("[data-qty-plus]");
      this.minNote = el.querySelector("[data-qty-min-note]");
      this.minNoteTimer = null;
      this.init();
    }

    init() {
      if (this.minusBtn) this.minusBtn.addEventListener("click", () => this.step(-1));
      if (this.plusBtn) this.plusBtn.addEventListener("click", () => this.step(1));
      if (this.input) this.input.addEventListener("change", () => this.clamp());
    }

    min() {
      const parsed = parseInt(this.input && this.input.min, 10);
      return Number.isNaN(parsed) ? 1 : parsed;
    }

    step(direction) {
      if (!this.input || this.input.disabled) return;
      const current = parseInt(this.input.value, 10) || this.min();
      const next = Math.max(this.min(), current + direction);
      if (next === current) {
        // Stepping below the minimum is blocked — surface why (mirrors the cart).
        if (direction < 0) this.showMinNote();
        return;
      }
      this.input.value = next;
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    showMinNote() {
      if (!this.minNote) return;
      this.minNote.classList.add("is-visible");
      clearTimeout(this.minNoteTimer);
      this.minNoteTimer = setTimeout(() => {
        this.minNote.classList.remove("is-visible");
      }, 4000);
    }

    clamp() {
      if (!this.input) return;
      const value = parseInt(this.input.value, 10);
      this.input.value = Number.isNaN(value) || value < this.min() ? this.min() : value;
    }
  }

  window.DigitalizModules.ProductQuantity = ProductQuantity;

  function init(root) {
    (root || document).querySelectorAll("[data-qty-stepper]").forEach((el) => {
      if (el.dataset.qtyBound === "true") return;
      el.dataset.qtyBound = "true";
      new ProductQuantity(el);
    });
  }

  init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
}
